import { Skeleton } from "@mui/material";
import CompensationTable from "./CompensationTable";
import { CompensationTableProps } from "./types";

export default function Compensation(props: Readonly<CompensationTableProps>) {
	const { loading, dataPresent } = props;

	if (loading) {
		return <Skeleton variant="rectangular" className="rounded-[6px] min-h-[150px] w-full" />;
	}

	return <>{dataPresent && <CompensationTable {...props} />}</>;
}
